<section>
    <div class=content>
        <div class="wrapper-1">
          <div class="wrapper-2">
            <h1>Thank you !</h1>
            <p>Thanks for submitting your enquiry to our Website.  </p>
            <p>You should receive a Email/Call soon to discusse further  </p>
        <button class="btn back_btn" routerLink="">
            Back To Home
           </button>
          </div>
      </div>
      </div>
        </section>
        <section>
            <footer class="">
                <div class="footerContent">
                    <div class="footer_sub_content">
                    <div class="row py-5">
                        <div class="col-md-4 d-flex">
                            <div class="footer_left right_border">
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/imgnew-kidzee/kidzee_yellow.png" width="100%" alt="">
                            </div>
                            <div class="footer_left">
                                <img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/imgnew-kidzee/zeeLearn_logo.png" width="100%" alt="">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="content_content">
                                <!-- <h6 class="text-white">For Admissions Enquiry,</h6> -->
                                <div class="mt-2">
                                <p class="text-white m-2">
                                    <img class="contect_icon" src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/imgkidzee-partner/footer_icon/Phone.png"><a  class="text-white m-0" href="tel:+919320063100">+91 93200 63100</a></p>
                                <p class="text-white m-2"><img class="contect_icon" src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/imgkidzee-partner/footer_icon/Mail.png">franchise&#64;kidzee.com</p>
                                <p class="text-white m-2"><img class="contect_icon" src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/imgkidzee-partner/footer_icon/Clock.png">Monday to Friday - 10 a.m. to 6 p.m.</p>
                            </div>
                        </div>
                        </div>
                        <div class="col-md-4">
                            <div class="location_content d-flex">
                                <img class="contect_icon" src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/imgkidzee-partner/footer_icon/location.png" height="20px" alt="">
                                <p>Zee Learn Limited, 135, Continental Building,B wing, Worli, Mumbai, Maharashtra 400018.</p>
                            </div>
                            <div class="midea_content">
                                <a href="https://www.facebook.com/KidzeeIndia" target="_blank"><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/imgnew-kidzee/fb.png" width="20px" height="20px" alt=""></a>
                                <a href="https://www.instagram.com/kidzeeindia/" target="_blank"><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/imgnew-kidzee/insta.png" class="mx-2" width="20px" height="20px" alt=""></a>
                                <a href="https://www.youtube.com/@KidzeeIndia" target="_blank"><img src="https://cdn.zeelearn.com/zeecms/kidzeeWeb-assets/imgnew-kidzee/youtube.png" class="mx-2" width="20px" height="20px" alt=""></a>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
            <div class="footer_year_text_content">
            <div class="row">
                <div class="col-md-12">
                    <div class="text-white text-center footerTextEmailId">
                        Copyright © 2025 Zee Learn Ltd. | T&C | Privacy Policy | Disclaimer
                    </div>
                </div>
            </div>
        </div>
            </footer>
        </section>